export function formatExampleValue (value) {
  if (value === undefined) return '—'
  if (value === null) return 'null'
  if (typeof value === 'number') return String(value)
  if (typeof value === 'string') return value
  if (typeof value === 'boolean') return String(value)
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}
